import { Masonry } from '@mui/lab'
import { Box, Paper, Typography, PaperProps, useMediaQuery, TypographyProps } from '@mui/material'
import { styled } from '@mui/system'

export const StyledMasonrySectionCentered = styled(Box)(({ theme }) => ({
  color: theme.palette.text.main,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  mt: theme.spacing(1),
}))

export const StyledMasonrySectionColumn = styled(Box)(({ theme }) => ({
  color: theme.palette.text.main,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

export const StyledMasonrySectionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
}))

type StyledMasonryTileProps = PaperProps & {
  padding?: string
}

export const StyledMasonryTile = styled(Paper)<StyledMasonryTileProps>(({ theme, padding = theme.spacing(4) }) => ({
  color: theme.palette.text.base,
  height: 'fit-content',
  padding: padding,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(2),
  backgroundImage: 'none',
  backgroundColor: theme.palette.background.elevation1,
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
}))

export const StyledMasonryForwardTile = styled(StyledMasonryTile)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  transition: 'all ease-in-out 150ms',
  ':hover': {
    backgroundColor: theme.palette.background.hover,
    cursor: 'pointer',
  },
}))

export const StyledMasonryTileTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.text.highEmphasis,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
}))

export const StyledTitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: '800',
}))

export const StyledMasonry = styled(Masonry)(() => ({
  width: '100%',
}))

export const StyledScheduleGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(3),
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}))

type ReportTypeMasonryTileProps = PaperProps & {
  selected?: boolean
  isDownSm?: boolean
}

export const ReportTypeMasonryTile = styled(Paper)<ReportTypeMasonryTileProps>(({ theme, selected }) => ({
  height: 'fit-content',
  padding: theme.spacing(useMediaQuery(theme.breakpoints.down('sm')) ? 1.5 : 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  borderRadius: theme.spacing(1),
  backgroundColor: !selected ? theme.palette.background.elevation2 : theme.palette.primary.light,
  transition: 'all 150ms ease-in-out',
  ':hover': {
    backgroundColor: !selected ? theme.palette.background.elevation9 : theme.palette.primary.lightHover,
    cursor: 'pointer',
  },
  ':focus': {
    backgroundColor: !selected ? theme.palette.background.elevation9 : theme.palette.primary.lightHover,
    outline: 'none',
  },
}))

export const SettingTypeMasonryTile = styled(Paper)<ReportTypeMasonryTileProps>(({ theme }) => ({
  height: 'fit-content',
  minHeight: theme.spacing(useMediaQuery(theme.breakpoints.down('lg')) ? 'none' : '116px'),
  padding: theme.spacing(useMediaQuery(theme.breakpoints.down('sm')) ? 1.5 : 3),
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: theme.spacing(3),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.elevation2,
  transition: 'all 150ms ease-in-out',
  ':hover': {
    backgroundColor: theme.palette.background.elevation9,
    cursor: 'pointer',
  },
}))

export const ReportTypeMasonryTileIcon = styled(Box)<ReportTypeMasonryTileProps>(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  color: theme.palette.text.mediumEmphasis,
  padding: theme.spacing(useMediaQuery(theme.breakpoints.down('sm')) ? 1 : 1.5),
  borderRadius: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  transition: 'all 150ms ease-in-out',
}))

export const SettingTypeMasonryTileIcon = styled(Box)<ReportTypeMasonryTileProps>(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  color: theme.palette.text.mediumEmphasis,
  padding: theme.spacing(useMediaQuery(theme.breakpoints.down('sm')) ? 1 : 1.5),
  borderRadius: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  transition: 'all 150ms ease-in-out',
  maxWidth: 46,
  maxHeight: 46,
}))
